/* eslint-disable react/jsx-pascal-case */
import { Type } from '@uswitch/spark';
import { useCategoryGuides } from './use-category-guides';
import { Fragment } from 'react';
import { usePageProps } from '../../compounds/category-guide-card';
import { categoryGuidesStylePath } from './index';
import { LinkWithChevron as Link } from '@uswitch/ev-core/react';
import { Fragment as _Fragment } from "theme-ui/jsx-runtime";
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var Item = function Item(_ref) {
  var _guide$fields, _guide$fields$variant, _guide$fields2, _guide$fields3;

  var guide = _ref.guide;
  var connectedEntity = guide !== null && guide !== void 0 && (_guide$fields = guide.fields) !== null && _guide$fields !== void 0 && (_guide$fields$variant = _guide$fields.variants) !== null && _guide$fields$variant !== void 0 && _guide$fields$variant.length ? guide === null || guide === void 0 ? void 0 : (_guide$fields2 = guide.fields) === null || _guide$fields2 === void 0 ? void 0 : _guide$fields2.variants[0] : (guide === null || guide === void 0 ? void 0 : (_guide$fields3 = guide.fields) === null || _guide$fields3 === void 0 ? void 0 : _guide$fields3.entry) || guide.fields.link;

  var _usePageProps = usePageProps({
    entity: connectedEntity
  }),
      mappedProps = _usePageProps.mappedProps;

  if (!connectedEntity) {
    return _jsx(_Fragment, {});
  }

  return _jsx("div", {
    children: _jsx(Link, {
      href: guide.fields.url,
      sx: {
        variant: categoryGuidesStylePath('link')
      },
      name: mappedProps.title,
      sys: connectedEntity.sys,
      children: mappedProps.title
    })
  });
};

var HtmlSitemapCategoryGuides = function HtmlSitemapCategoryGuides(_ref2) {
  var title = _ref2.title,
      _ref2$guides = _ref2.guides,
      guides = _ref2$guides === void 0 ? [] : _ref2$guides;
  var filteredGuides = useCategoryGuides({
    guides: guides
  }).sort(function (a, b) {
    return a.fields.url.localeCompare(b.fields.url);
  }).filter(function (url) {
    return !url.fields.robotsMeta;
  });
  return filteredGuides.length !== 0 ? _jsxs(Fragment, {
    children: [title ? _jsx(Type.H3, {
      sx: {
        variant: categoryGuidesStylePath('title')
      },
      children: title
    }) : null, filteredGuides.map(function (url, key) {
      return _jsx(Item, {
        guide: url
      }, url.fields.url);
    }, this)]
  }) : null;
};

export default HtmlSitemapCategoryGuides;
//# sourceMappingURL=html-sitemap.js.map